<ul class="m-0 p-0 list-none flex flex-col gap-2">
  @for (item of model; track $index) {
    <li app-menuitem [item]="item" [index]="$index" [root]="false"></li>
  }
</ul>
